export const UPCOMING_TARGET_HORIZON_DAYS = 42;
export const UPCOMING_TARGET_DUE_NOW_DAYS = 7;
export const UPCOMING_TARGET_LIMIT = 12;
export const UPCOMING_TARGET_HOME_RADIUS_MILES = 20;
export const UPCOMING_TARGET_MIN_LOCAL_YEARS = 2;
